import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  key: 2,
  class: "vab-dot vab-dot-error"
};
import { useSettingsStore } from '@/store/modules/settings';
import { isExternal } from '@/utils/validate';
import { translate } from '@/i18n';
import { isHashRouterMode } from '@/config';

import { useRoute, useRouter } from 'vue-router';
import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabMenuItem',
  props: {
    itemOrMenu: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const $pub = inject('$pub');
    const settingsStore = useSettingsStore();
    const {
      device
    } = storeToRefs(settingsStore);
    const {
      foldSideBar
    } = settingsStore;
    const handleLink = () => {
      const routePath = props.itemOrMenu.path;
      const target = props.itemOrMenu.meta.target;
      if (target === '_blank') {
        if (isExternal(routePath)) window.open(routePath);else if (route.path !== routePath) isHashRouterMode ? window.open(`/#${routePath}`) : window.open(routePath);
      } else {
        if (isExternal(routePath)) window.location.href = routePath;else if (route.path !== routePath) {
          if (device.value === 'mobile') foldSideBar();
          router.push(props.itemOrMenu.path);
        } else $pub('reload-router-view');
      }
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      return _openBlock(), _createBlock(_component_el_menu_item, {
        index: __props.itemOrMenu.path,
        onClick: handleLink
      }, {
        default: _withCtx(() => [__props.itemOrMenu.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
          key: 0,
          icon: __props.itemOrMenu.meta.icon,
          "is-custom-svg": __props.itemOrMenu.meta.isCustomSvg,
          title: _unref(translate)(__props.itemOrMenu.meta.title)
        }, null, 8, ["icon", "is-custom-svg", "title"])) : _createCommentVNode("", true), _createElementVNode("span", {
          title: _unref(translate)(__props.itemOrMenu.meta.title)
        }, _toDisplayString(_unref(translate)(__props.itemOrMenu.meta.title)), 9, _hoisted_1), __props.itemOrMenu.meta.badge ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          effect: "dark",
          type: "danger"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.itemOrMenu.meta.badge), 1)]),
          _: 1
        })) : _createCommentVNode("", true), __props.itemOrMenu.meta.dot ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[0] || (_cache[0] = [_createElementVNode("span", null, null, -1)]))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["index"]);
    };
  }
});